export default {
  GET_VARIANT_COLORS: (state) => state.variantColors,
  GET_VARIANT_COLOR: (state) => state.variantColor,
};
